import { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import DefaultLayout from './DefaultLayout';
import { changeAppLanguage, isAppLocale } from '@/lib/i18n/documentLocale';

export default function LocaleLayout() {
    const { locale } = useParams<{ locale: string }>();

    useEffect(() => {
        if (isAppLocale(locale)) {
            void changeAppLanguage(locale);
        }
    }, [locale]);

    if (!isAppLocale(locale)) {
        return <Navigate to="/ar" replace />;
    }

    return <DefaultLayout />;
}
